import PropTypes from 'prop-types'
import { useContext, useEffect } from 'react'
import { AuthContext } from './Auth'
import { openModal } from 'lib/utils/store/modals'
// import { logException } from 'lib/errors'
import { matchPath, useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

const getVerifyMapAlmaUserResponseErrorMessage = (t, verifyMapAlmaUserResponseError) => {
    let message

    switch (verifyMapAlmaUserResponseError) {
    case 'no_personal_account_error_message':
        message = t('common:login.noPersonalAccountError')
        break
    default:
        message = verifyMapAlmaUserResponseError
    }

    return message
}

const AuthErrorHandler = ({ loggedIn, currentUserLoading }) => {
    const auth = useContext(AuthContext)
    const history = useHistory()
    const location = useLocation()
    const { t, i18n } = useTranslation()

    useEffect(() => {
        if (auth.verifyMapAlmaUserResponseError) {
            const isAccountConfirmationError = auth.verifyMapAlmaUserResponseError.indexOf('Vahvista sähköpostiosoitteesi') !== -1

            if (isAccountConfirmationError) {
                const isVerifyRoute = !!matchPath(location.pathname, {
                    path: `${getLocale(i18n.language)}/user/register/verify`,
                    exact: false,
                    strict: false,
                })

                if (!isVerifyRoute) {
                    history.replace(`${getLocale(i18n.language)}/user/register/verify`)
                }
            } else {
                openModal('auth-failed-message', {
                    message: getVerifyMapAlmaUserResponseErrorMessage(t, auth.verifyMapAlmaUserResponseError)
                })
            }
        }
    }, [t, auth, history, location, i18n.language])

    // useEffect(() => {
    //     if (!currentUserLoading && !loggedIn && auth.almaAuthData?.user && !auth.verifyMapAlmaUserResponseError) {
    //         logException('Invalid session: Valid Alma session exists, but API auth failed. Require user to logout from Alma session.')
    //         openModal('auth-failed-message', { message: t('common:login.invalidApiSession') })
    //     }
    // }, [t, currentUserLoading, loggedIn, auth.almaAuthData, auth.actions, auth.verifyMapAlmaUserResponseError])

    return null
}

AuthErrorHandler.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
    currentUserLoading: PropTypes.bool.isRequired,
}

export default AuthErrorHandler
